import Col from 'react-bootstrap/Col'
import Alert from 'react-bootstrap/Alert'
import {CSSTransition} from 'react-transition-group'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {useRef} from "react";

interface AlertCustomInterface {
  bodyContent?: boolean|string|Element,
  bodyContentHtml?: string,
  bodyContentBold?: string,
  bodyContentItalic?: string,
  bodyIcon?: boolean,
  bodyIconName?: string,
  bodyIconType?: string,
  classname?: string,
  dismissible?: boolean,
  heading?: boolean,
  headingIconName?: string,
  headingIconType?: string,
  headingTitle?: string,
  onClose?: Function,
  transition?: boolean,
  variant: string,
  col?: number,
}

const AlertCustom = ({
  bodyContent,
  bodyContentHtml,
  bodyContentBold,
  bodyContentItalic,
  bodyIcon,
  bodyIconName,
  bodyIconType,
  classname,
  dismissible,
  heading,
  headingIconName,
  headingIconType,
  headingTitle,
  onClose,
  transition,
  variant,
  col = 12,
}: AlertCustomInterface) => {
  const nodeRef = useRef(null);

  return (
    <>
      <CSSTransition
        in={transition}
        timeout={500}
        classNames="alert"
        nodeRef={nodeRef}
        unmountOnExit>
        <Col xs={col} className="d-flex justify-content-center p-0">
          <Alert
            transition={false}
            onClose={transition && onClose}
            dismissible={transition && (dismissible || false)}
            variant={variant}
            className={classname || 'm-3'}>
            {heading && (
              <Alert.Heading>
                <FontAwesomeIcon
                  icon={[
                    headingIconType || 'fas',
                    headingIconName || 'exclamation-triangle',
                  ]}
                  className="mr-1"
                />
                {headingTitle || 'Oups ! Une erreur est survenue.'}
              </Alert.Heading>
            )}
            {bodyIcon && (
              <FontAwesomeIcon
                icon={[bodyIconType || 'fas', bodyIconName || 'info-circle']}
                className="mr-1"
              />
            )}
            {bodyContent}
            {bodyContentHtml && (
              <span
                dangerouslySetInnerHTML={{
                  __html: bodyContentHtml,
                }}></span>
            )}
            {bodyContentBold && (
              <div className="fs-14 font-weight-bold mt-2">
                {bodyContentBold}
              </div>
            )}
            {bodyContentItalic && (
              <div className="fs-14 font-italic">{bodyContentItalic}</div>
            )}
          </Alert>
        </Col>
      </CSSTransition>
    </>
  )
}

export default AlertCustom
